import React, { createContext, useContext, useState } from 'react';

interface AdminAuthContextValue {
  isAuthenticated: boolean;
  login(username: string, password: string): boolean;
  logout(): void;
  getAuthHeader(): string;
}

const AdminAuthContext = createContext<AdminAuthContextValue | undefined>(undefined);

const ADMIN_KEY = 'cg_admin_auth';

export function AdminAuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return localStorage.getItem(ADMIN_KEY) === 'true';
  });

  function login(username: string, password: string): boolean {
    // Credenciais mockadas: admin/admin
    if (username === 'admin' && password === 'admin') {
      localStorage.setItem(ADMIN_KEY, 'true');
      setIsAuthenticated(true);
      return true;
    }
    return false;
  }

  function logout() {
    localStorage.removeItem(ADMIN_KEY);
    setIsAuthenticated(false);
  }

  function getAuthHeader(): string {
    // Basic Auth: admin:admin em base64
    return 'Basic ' + btoa('admin:admin');
  }

  const value: AdminAuthContextValue = {
    isAuthenticated,
    login,
    logout,
    getAuthHeader
  };

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth deve ser usado dentro de AdminAuthProvider');
  return ctx;
}
